import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './store'
import App from './components/App'
import * as serviceWorker from './serviceWorker'
import { AuthProvider } from './authContext'

const root = document.getElementById('root')

ReactDOM.render(
  <AuthProvider>
    <Provider store={configureStore()}>
      <App />
    </Provider>
  </AuthProvider>,
  root
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
